import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 0 24px;
  width: 100%;
  height: calc(100vh - 50px);
`;

export const ToastConfirmacao = styled.div`
  display: flex;
  flex-direction: column;
  align-items: left;
  text-align: left;

  background-color: #0cad0f;
  border-radius: 8px;
  padding: 18px;
  width: 100%;
  max-width: 360px;

  #toast-title {
    font-family: Nunito;
    font-weight: 700;
    font-size: 16px;
    color: #ffffff;
  }

  #toast-info {
    font-family: Nunito;
    font-weight: 400;
    font-size: 14px;
    color: #ffffff;
  }
`;
